export const AddAdHocDocuments_uischema = {
  name: "Add Ad Hoc Document(s)",
  pageInfo: {
    text: "Use this form to upload documents to your submitted application. Uploaded documents will be added to case documents. Please check the correspondence issued for details on what is required for your case.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Ad_Hoc_Document_Upload" },
          accept_multiple: true,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "fileType",
          widget: "select",
          label: "Document Category",
          selection: ["Upload Additional Documents"],
          validate: ["required"],
          tooltip: `Enter the document type of the Ad Hoc Document.`,
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
        },
      ],
    },
  ],
};
